import {Column, HeaderProps} from 'react-table'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../utils/components/table-content/CustomHeader'
import {Link} from 'react-router-dom'
import {IRouteSenderRoles} from './_model'
import RouteSenderStatusCell from './RouteSenderStatusCell'
import {KTIcon} from '../../../_metronic/helpers'

const routesSenderRolesColumn = (
  handleSelect: (id: number) => void
): ReadonlyArray<Column<IRouteSenderRoles>> => {
  const onEdit = (id: number) => handleSelect(id)

  return [
    // {
    //   Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    //   id: 'selection',
    //   Cell: ({...props}) => (
    //     <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    //   ),
    // },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='name' className='min-w-100px' />
      ),
      id: 'name',
      accessor: 'name',
      Cell: ({...props}) => (
        <Link
          to={`${props.data[props.row.index].name}/${props.data[props.row.index].id}`}
          state={props.data[props.row.index].id}
        >
          {props.data[props.row.index].name}
        </Link>
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='type' className='min-w-100px' />
      ),
      id: 'type',
      accessor: 'type',
      // Cell: ({...props}) => (
      //   <span>{props.data[props.row.index].type === '1' ? 'Route' : 'Sender'}</span>
      // ),
    },
    // {
    //   Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
    //     <CustomHeader tableProps={props} title='type' className='min-w-100px' />
    //   ),
    //   id: 'type',
    //   Cell: ({...props}) => (
    //     <div className=''>
    //       <p className='badge badge-light-primary'>
    //         {props.data[props.row.index].type === '1' ? 'Route' : 'Sender'}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='source name' className='min-w-100px' />
      ),
      id: 'sourceName',
      accessor: 'sourceName',
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='destination name' className='min-w-100px' />
      ),
      id: 'destinationName',
      accessor: 'destinationName',
    },
    // {
    //   Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
    //     <CustomHeader tableProps={props} title='sender_id' className='min-w-100px' />
    //   ),
    //   id: 'sender_id',
    //   accessor: 'sender_id',
    // },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='status' className='min-w-100px' />
      ),
      id: 'status',
      Cell: ({...props}) => <RouteSenderStatusCell status={props.data[props.row.index].status} />,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<IRouteSenderRoles>>) => (
        <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
      ),
      id: 'action',
      Cell: ({...props}) => (
        <div className='text-end'>
          <a
            href='#'
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 mb-1'
            onClick={() => onEdit(props.data[props.row.index].id)}
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_2'
          >
            <KTIcon iconName='pencil' className='fs-3' />
          </a>
        </div>
      ),
    },
  ]
}

export default routesSenderRolesColumn
